(function() {
    'use strict';

    angular
        .module('cloudApp')
        .factory('CompanyRegister', CompanyRegister);

    CompanyRegister.$inject = ['$resource'];

    function CompanyRegister($resource) {
        var service = $resource(SERVER_API_URL+'api/registerdbhawk/:company/:invite',  {company: '@company', invite: '@invite'}, {
            dbhawk :{method: 'POST'}
        });

        return service;
    }
})();
